export enum UserRole {
  Admin = 'admins',
  Teacher = 'teachers',
}

export enum ModuleActions {
  Delete = 'delete',
  Edit = 'edit',
  EditName = 'editname',
  Link = 'link',
  Lock = 'lock',
}
